export const LOADING = 'GOOGLE_LOADING';
export const GET_CITIESBILLING_ASSISTANT_GOOGLE = 'GOOGLE_GET_CITIESBILLING_ASSISTAN';
export const GET_CITIESSERVICE_ASSISTANT_GOOGLE = 'GOOGLE_GET_CITIESSERVICE_ASSISTAN';
